module.exports = __webpack_public_path__ + "static/media/promo-1.75f7ab18.png";